import { Box, Drawer, Grid, IconButton, Toolbar, Tooltip, Typography, styled } from "@mui/material";
import imgSTLogo from "assets/images/Logo/Logo.png";
import AvatarIcon from "components/Layout/components/Avatar";
import "./Header.css";
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
import { Link, useLocation } from "react-router-dom";
import { useContext, useEffect } from "react";
import { ProviderLayout } from "view/ExampleLayout/Admin";
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import MenuBar from "components/Layout/Menu/Layout1";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import LogoutIcon from '@mui/icons-material/Logout';
import { FnAxios, RouterDOM } from "utilities/utilities";
import BoxTextSize from "components/Layout/BoxTextSize";
import { EnumHistory } from "enum/enum";
interface AppBarProps extends MuiAppBarProps {
    open?: boolean;
}

const AppBar = styled(MuiAppBar)<AppBarProps>(({ theme }) => ({
    zIndex: 1500,
    width: '100%',
    height: '58px !important',
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
}));

const Header = () => {
    const Router = RouterDOM();
    const location = useLocation();
    const AxiosFn = FnAxios();

    const {
        Layout630,
        open,
        setOpen
    } = useContext(ProviderLayout);

    useEffect(() => {
        if (open) {
            setOpen(false)
        }

        let param = {
            sPathName: location.pathname,
            nActionID: EnumHistory.view
        };
        AxiosFn.Post(`HistoryReport/OnSaveHistory`, param, (result) => {
           
        }, (err) => {
            Router.GoToPage("/Home");
            window.location.reload();
        });
        window.scrollTo(0, 0);
    }, [location])

    return (
        <Box sx={{ display: 'flex' }}>
            <AppBar className={"div-backgournd-header"} style={{ display: Layout630 ? "" : "none" }}>
                <Toolbar>
                    <Grid container alignItems='center' justifyContent={"space-between"}>
                        <Grid item xs={'auto'}>
                            <Grid container alignItems='center' spacing={1} sx={{ flexGrow: 1 }} >
                                <Grid item xs={'auto'}>
                                    <Link to="/Home" preventScrollReset={true}>
                                        <Box
                                            component="div"
                                            className="img-logo2"
                                            sx={{
                                                backgroundImage: `url(${imgSTLogo})`,
                                            }}
                                        />
                                    </Link>
                                </Grid>
                                <Grid item xs={'auto'}>
                                    <Typography className={"span-title-1"}>
                                        กองทุนจัดการซากดึกดำบรรพ์
                                    </Typography>
                                    <Typography className={"span-title-2"}>
                                        คุ้มครอง อนุรักษ์ และบริหารจัดการอย่างยั่งยืน
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={'auto'}>
                            <Grid container spacing={1} justifyContent={"flex-end"} alignItems="center" style={{ display: Layout630 ? "" : "none" }}>
                                <Grid item>
                                    {/* <NotificationIcon></NotificationIcon> */}
                                    <AvatarIcon isName={true}></AvatarIcon>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Toolbar>
                <BoxTextSize isFrontEnd={false} /> {/* เปลี่ยนขนาดตัวอักษร */}
            </AppBar >

            <AppBar className={"div-backgournd-headerPhone"} style={{ display: !Layout630 ? "" : "none" }}>
                <Toolbar>
                    <Grid container alignItems='center' justifyContent={"space-between"}>
                        <Grid item xs={'auto'}>
                            <Grid container alignItems='center' spacing={1} sx={{ flexGrow: 1 }} >
                                <Grid item xs={'auto'}>
                                    <IconButton
                                        aria-label="menu"
                                        edge="start"
                                        style={{ left: '10px' }}
                                        onClick={() => { setOpen(e => !e) }}
                                    >
                                        <MenuRoundedIcon style={{ color: 'black' }} />
                                    </IconButton>
                                </Grid>
                                <Grid item xs={'auto'}>
                                    <Link to="/Home" preventScrollReset={true}>
                                        <Box
                                            component="div"
                                            className="img-logoPhone2"
                                            sx={{
                                                backgroundImage: `url(${imgSTLogo})`,
                                            }}
                                        />
                                    </Link>
                                </Grid>
                                <Grid item xs={'auto'} >
                                    <Typography className={"span-title-Phone1"}>
                                        กองทุนจัดการซากดึกดำบรรพ์
                                    </Typography>
                                    <Typography className={"span-title-Phone2"}>
                                        คุ้มครอง อนุรักษ์ และบริหารจัดการอย่างยั่งยืน
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Toolbar>
                <BoxTextSize isFrontEnd={false} /> {/* เปลี่ยนขนาดตัวอักษร */}
            </AppBar >

            <Drawer
                anchor="left"
                open={open}
                onClose={() => { setOpen(e => !e) }}
            >
                <Grid container spacing={1} flexDirection={"column"} justifyContent={"space-between"} style={{ marginTop: Layout630 ? "1px" : '58px', minHeight: '100vh' }}>
                    <Grid item>
                        <MenuBar />
                    </Grid>
                    <Grid item>
                        <Tooltip title={"ออกจากระบบ"} placement="right">
                            <List disablePadding>
                                <ListItem disablePadding>

                                    <ListItemButton
                                        className={`nav-menu-item nav-menu-item-lv1`}
                                        sx={{ pl: "16px", minWidth: '40px' }}
                                        onClick={() => { Router.GoToPage("/login") }}
                                    >
                                        <ListItemIcon sx={{ ml: '2px' }}>
                                            <LogoutIcon />
                                        </ListItemIcon>
                                        <ListItemText primary={"ออกจากระบบ"} primaryTypographyProps={{ style: { whiteSpace: "nowrap", overflow: 'hidden', textOverflow: 'ellipsis' } }} />
                                    </ListItemButton>
                                </ListItem>
                            </List>
                        </Tooltip>
                    </Grid>
                </Grid>
            </Drawer>
        </Box >
    )
}
export default Header;
